import React from 'react';
import { Modal } from 'antd';
import { modal } from '../../../Tasks/configs/designTokens';
import '../../styles/index.scss';

const TagInstallationInstructionsModal = ({ isModalVisible, setIsModalVisible }) => {
  return (
    <React.Fragment>
      <Modal
        title={'Tag Installation Instructions'}
        wrapClassName="tags-modal"
        width={modal.wide}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        centered
        footer={null}
      >
        <>
          <iframe
            src={`${process.env.REACT_APP_INTERNAL_MICROSERVICE_URL}/api/docs/html?filename=integrations%2Ftag-installation.md`}
            title={'Tag Installation Instructions'}
            width="100%"
            height="800px"
            className="tags-modal__iframe"
          />
        </>
      </Modal>
    </React.Fragment>
  );
};

export default TagInstallationInstructionsModal;
